import { render, staticRenderFns } from "./NotificationsDialog.vue?vue&type=template&id=04e21a11&scoped=true&"
import script from "./NotificationsDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationsDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDialog.vue?vue&type=style&index=0&id=04e21a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e21a11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
